<template>
  <TButtonGroup>
    <TGroupButton
      data="bold"
      tooltip="Bold"
      toggle
      small
      :active="isBoldActive"
      :inverse="inverse"
      @button-clicked="toggleBold"
    >
      <font-awesome-icon :icon="['fas', 'bold']" />
    </TGroupButton>
  </TButtonGroup>
</template>

<script setup lang="ts">
import { expandSelectionToWord, getActiveMarks } from "../_internal/cutomExtensions";
import { TButtonGroup, TGroupButton } from "@topol/twig-ui";
import { Editor } from "@tiptap/core";
import { computed } from "vue";

const props = defineProps<{
  editor: Editor;
  inverse?: boolean;
}>();

const isBoldActive = computed(() => {
  if (!props.editor) return false;

  // Check stored marks first (for empty paragraphs)
  const marks = getActiveMarks(props.editor);
  const hasBoldMark = marks.some((mark) => mark.type.name === "bold");
  if (hasBoldMark) return true;

  // Fallback to editor.isActive
  return props.editor.isActive("bold");
});

function toggleBold() {
  if (!props.editor) return;
  expandSelectionToWord(props.editor);
  props.editor.chain().focus().toggleBold().run();
}
</script>
